import type { GasPayload } from '@atlaskit/analytics-gas-types';

export const onSuggestedQueryOperational = ({
	success,
	attributes,
	nonPrivacySafeAttributes,
}: {
	success: boolean;
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	source: 'searchDialog',
	eventType: 'operational',
	action: success ? 'taskSuccess' : 'taskFail',
	actionSubject: 'suggestedQuery',
	attributes,
	nonPrivacySafeAttributes,
});
